export const initOptions = (context, key, defaults) => {
	context[key].options = {
		...defaults,
		...context[key].options
	};
};
